export default __webpack_public_path__ + "static/media/29_desktop.8c03280f.jpg";